import React, { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useRouteMatch } from "react-router-dom";
import { Col, Dropdown, Row } from 'react-bootstrap';
import { filterMapEgList, setReplayParams } from '../../../actions/map';
import { getCrewList, selectedCrew } from '../../../actions/crew';
import { selectRegions } from '../../../actions/geo';
import { getEquipmentGroupList, selectedEquipmentGroup, setSelectedEG } from '../../../actions/equipment-group';
import { crewAnalyzeInfo } from '../../../actions/analyze';
import { getDrawingInstance } from "../../../components/map/geo/DrawingControl";
import { isCustom } from '../../../helpers/common';
import '../../../../assets/scss/newdropdown.scss';

const QuickSearch = () => {
    
    const dispatch = useDispatch();

    const farmId = useSelector(state => state.farm.currentFarm.farm_uuid);
    const crewList = useSelector(state => state.crew.crewList);
    const equipmentGroupList = useSelector(state => state.equipmentGroup.equipmentGroupList);
    const regionsList = useSelector(state => state.geo.regionsList);
    //const selectedRegionIds = useSelector(state => state.geo.selectedRegionIds);
    const search = useSelector(state => state.analyze.searchParams);
    const selectedPlanType = useSelector(state => state.plan.selectedPlanType);

    //const { rangeId, range, customRange, custom } = search;
    //const { crewList, search, farmId, equipmentGroupList, regionsList, selectedPlanType } = props;
    const list = ["CREW", "IMPLEMENT", "TRANSPORT", "FIELD"];

    const history = useHistory();
    const match = useRouteMatch();

    const [searchText, setSearchText] = useState();
    const [filteredData, setFilteredData] = useState([]);
    const [options, setOptions] = useState([]);
    const [showOptions, setShow] = useState(true);
    const [onClick, setOnClick] = useState(false);

    useEffect(() => {
        dispatch(getCrewList({
            farmId,
            fromDate: isCustom(search.range) ? search.custom.from : null,
            toDate: isCustom(search.range) ? search.custom.to : null,
            selectedPlanType: selectedPlanType
        }));
        dispatch(getEquipmentGroupList({ farmId, crew: 1, device: 1, selectedPlanType: selectedPlanType }));
    }, []);

    useEffect(() => {
        setSearchText('');
        dispatch(getCrewList({
            farmId,
            fromDate: isCustom(search.range) ? search.custom.from : null,
            toDate: isCustom(search.range) ? search.custom.to : null,
            selectedPlanType: selectedPlanType
        }));
        dispatch(getEquipmentGroupList({ farmId, selectedPlanType: selectedPlanType }));
        // if (search && search.custom && search.custom.from) props.actions.getGeoRegionList(farmId, false, { ...search.custom });
        dispatch(selectedCrew([]));

        dispatch(selectedEquipmentGroup(null));
    }, [farmId, selectedPlanType]);

    useEffect(() => {
        const crews = crewList.filter(item => item.active && !item.is_end_crew && item.plan_type_id === selectedPlanType).map(e => {
            return {
                id: e.crew_uuid,
                value: e.crew_name,
                key: "CREW"
            }
        });

        // const EG = equipmentGroupList.map(e => {
        //     return {
        //         id: e.equipment_group_uuid,
        //         value: e.equipment_group_name,
        //         crews: e.crews,
        //         isTruck: e.vehicle.is_truck,
        //         key: "EQUIPMENT GROUP"
        //     }
        // }); 

        const implement = equipmentGroupList.filter(item => !item.vehicle.is_truck && item.plan_type_id === selectedPlanType).map(e => {
            return {
                id: e.equipment_group_uuid,
                value: e.equipment_group_name,
                crews: e.crews,
                isTruck: e.vehicle.is_truck,
                key: "IMPLEMENT"
            }
        });

        const transport = equipmentGroupList.filter(item => item.vehicle.is_truck && item.plan_type_id === selectedPlanType).map(e => {
            return {
                id: e.equipment_group_uuid,
                value: e.equipment_group_name,
                crews: e.crews,
                isTruck: e.vehicle.is_truck,
                key: "TRANSPORT"
            }
        });

        const fields = regionsList.filter(e => e.active && e.geo_region_type_id === 2).map(item => {
            return {
                id: item.geo_region_uuid,
                value: item.geo_region_name,
                key: "FIELD"
            }
        })

        setOptions([...crews, ...implement, ...transport, ...fields]);
    }, [crewList, equipmentGroupList, regionsList]);

    useEffect(() => {
        if (searchText) {
            const data = [];
            const filterdList = options.filter(e => e.value.toLowerCase().includes(searchText.toLowerCase()));

            list.forEach(subHeader => {
                const groupedData = filterdList.filter(item => item.key === subHeader);

                if (groupedData.length !== 0) {
                    data.push({
                        key: subHeader,
                        data: groupedData
                    })
                }
            })

            setFilteredData(data);
            setShow(true);
        } else {
            setShow(false);
            // setFilteredData([]);
        }
    }, [searchText]);

    useEffect(() => {
        onClick ? setShow(false) : setShow(true);
    }, [onClick])

    const handleClick = (item) => {
        setSearchText(item.value);

        if (item.key === "CREW") {
            let replay = {};
            const isEndCrew = item.is_end_crew;
            if (!isEndCrew) replay = { range: 1 };

            dispatch(selectedCrew(item.id));
            dispatch(filterMapEgList({ crewIds: [item.id] }));
            dispatch(setReplayParams({ enable: !isEndCrew, enabledDate: null, ...replay }));
            dispatch(crewAnalyzeInfo(item.id, item.crew_name));

            history.push(`${match.url}/map/crew/${item.id}?t=sub&sub=1`);
        }

        if (item.key === "TRANSPORT" || item.key === "IMPLEMENT") {
            dispatch(selectedEquipmentGroup(item));
            dispatch(setSelectedEG([item.id]));
            history.push(`${match.url}/map/eg?t=sub&sub=1`);
        }

        if (item.key === 'FIELD') {
            showMap(item.id);
            dispatch(selectRegions([item.id]));
            history.push(`${match.url}/map/georegion?t=sub&sub=1`);
        }
        setOnClick(true);
    };

    const showMap = useCallback((id) => {
        const showRegion = getDrawingInstance();
        showRegion.showShapeGroups(id, true);
        showRegion.setBounds(id);
    }, [])

    return (
        <div className="quicksearch">
            <Dropdown className="filter-dropdown-container" show={true} onToggle={() => setShow(false)}>
                <Dropdown.Menu align="center" className="dropdownmenu" >
                    <div className="input-search-container searchBox">
                        <div className="input-with-icon">
                            <div className='searchIcon'><i className="fa fa-search searchIcon" aria-hidden={true} /></div>
                            <input
                                type="text"
                                placeholder="Search"
                                value={searchText || ''}
                                onFocus={() => setOnClick(false)}
                                onChange={e => setSearchText(e.target.value)}
                            />
                            {searchText ?
                                <i className="fa fa-times-circle closeIcon" aria-hidden={true} onClick={() => setSearchText("")} /> :
                                <></>}
                        </div>
                    </div>

                    {showOptions && <div className="options pt-2">
                        {filteredData.length > 0 ? filteredData.map((e, i) => {
                            return (
                                <div key={i}>
                                    {i > 0 ? <hr className='m-0' /> : <></>}
                                    <h6 className="my-2" style={{ color: "grey", marginLeft: "15px", fontSize: "15px" }}>{e.key}</h6>
                                    {e.data.length < 6 ?
                                        e.data.map((item, i) => <div onClick={click => handleClick(item)} className='quick-search-options' style={{ marginLeft: "45px", cursor: "pointer" }} key={i}>
                                            <p>{item.value}</p>
                                        </div>)
                                        :
                                        <Row className="row row-cols-3">{e.data.map((item, i) =>
                                            <Col onClick={click => handleClick(item)} className='quick-search-options col-5' style={{ marginLeft: "45px", cursor: "pointer" }} key={i}>
                                                <p>{item.value}</p>
                                            </Col>)}
                                        </Row>
                                    }
                                </div>
                            )
                        }) : searchText ? <div className='no-option'>No Option</div> : <></>}
                    </div>}
                </Dropdown.Menu>
            </Dropdown>
        </div >
    )
}

/* const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        getCrewList, getEquipmentGroupList, getGeoRegionList, setReplayParams,
        filterMapEgList, clearMapFilters, crewAnalyzeInfo, selectedCrew,
        planAnalyzeInfo, egAnalyzeInfo, analyzeParams, selectedEquipmentGroup, selectRegions, setSelectedEG
    }, dispatch)
}); */

/* const mapStateToProps = state => ({
    farmId: state.farm.currentFarm.farm_uuid,
    crewList: state.crew.crewList,
    equipmentGroupList: state.equipmentGroup.equipmentGroupList,
    regionsList: state.geo.regionsList,
    selectedRegionIds: state.geo.selectedRegionIds,
    search: {
        rangeId: state.analyze.searchParams.rangeId,
        range: state.analyze.searchParams.range,
        customRange: state.analyze.searchParams.customRange,
        custom: state.analyze.searchParams.custom
    },
    selectedPlanType: state.plan.selectedPlanType,
}); */

export default memo(QuickSearch);